module.exports = __webpack_public_path__ + "static/media/logo_pt2020.6710383d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_pt2020.svg
// module id = 323
// module chunks = 0